<template>
  <div class="user-detail">
    <div class="header-operate">
      <div class="left">

      </div>
      <div class="right">
        <template v-if="isEdit">
          <a-button @click="cancelEdit">
            {{$t('baseVO.cacel')}}
          </a-button>
          <a-button  type="primary" :loading="saveLoading" @click="updateEvent">
            {{$t('baseVO.save')}}
          </a-button>
        </template>
        <template  v-if="!isEdit">
          <a-button size="small" v-action:EMPLOYEECONTROLLER_EDITUSERINFO @click="isEdit = true">
            <pt-icon type="icon-bianji2"/>
            {{$t('user.tableRowOperate.edit')}}
          </a-button>
        </template>

      </div>
    </div>
    <div v-if="isEdit" class="user-content">
      <input-form :user-info="userInfo" ref="editForm" v-model="inductionInfo" :isEdit="isEdit" :own-edit="true" ></input-form>
    </div>
    <div v-else  class="user-content">
      <div class="top">
        <div class="left">
          <div class="header-image">
            <a-avatar :size="100" icon="user" :src="getImageUrl()"></a-avatar>
          </div>
          <div class="userName">
            <span>{{userInfo.userName}}&nbsp;&nbsp;({{userInfo.zhname}})</span>
          </div>
        </div>
        <div class="right"  >
          <div>{{$t('user.tableHeader.personnumber')}}&nbsp;&nbsp;:&nbsp;&nbsp;{{userInfo.personnumber}}</div>
        </div>
        <div class="right"  >
          <div>{{$t('user.tableHeader.company')}}&nbsp;&nbsp;:&nbsp;&nbsp;{{userInfo.companyName}}</div>
        </div>
      </div>
    </div>
    <!-- 详细信息 -->
    <div v-if="!isEdit">
      <induction-modal ref="inductionDetail" :empBrokerageInfo="empBrokerageInfo" :user-flag="true" :month="getMonths" :empInsuranceStandard="empInsuranceStandard" :yearSalary="yearSalary" :user-info="userInfo"></induction-modal>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapActions } from 'vuex'
  import EmpBrokerageApi from '@/api/manager/empbrokerage'
  import YearWorkApi from '@/api/manager/yearWork'
  import EmpInsuranceStandardApi from '@/api/manager/empInsuranceStandard'
  import inductionModal from './inductionModal'
  import inputForm from './inputForm'
  import moment from 'moment'
  import Api from '@/api/sys/user'
  import InductionInvitationApi from '@/api/sys/inductionInvitation'
  import {formTokenMixin} from '@/utils/mixin'
  import { mapState } from 'vuex'
  export default {
    name: 'detail',
    components:{
      inductionModal,inputForm
    },
    props: {

    },
    mixins:[formTokenMixin],
    data() {
      return {
        info:{},
        empBrokerageInfo: {},
        inductionId:undefined,
        url: null,
        isEdit:false,
        newUserInfo:{},
        saveLoading:false,
        inductionInfo:{},
        userInfo:{
          accountDO:{}
        },
        empInsuranceStandard:{},
        yearSalary:0,
        quitVO:{
          visible:false,
          loading:false,
        },
        resetPasswordLoading:false,
        unlockUserLoading:false,
        lockUserLoading:false,
      }
    },
    computed:{
      ...mapGetters(['accountId']),
      getMonths(){
        return moment().diff(moment(this.info.entrytime,'YYYY-MM-DD'),'months')
      },
      ...mapState({
        userDO: state => state.user.info
      }),
    },
    mounted() {
      this.initUserInfo()
    },
    methods: {
      moment,
      ...mapActions(['Logout']),
      initBrokerageInfo() {
        EmpBrokerageApi.selectByAccountId(this.userInfo.accountid).then(res => {
          if (res.code == 1) {
            this.empBrokerageInfo = res.data?res.data:{name:"~"}
            if(res.data){
              this.userInfo.brokerageId = res.data.brokerageScaleId
              this.userInfo.brokerageYear = res.data.year
            }
          }
        })
      },
      initYearSalary(){
        let year = moment().format("YYYY")
        YearWorkApi.getYearSalary(this.userInfo.accountid,year).then(res=>{
          if(res.code == 1){
            this.yearSalary = res.data
          }
        })
      },
      initEmpInsuranceStandard() {
        EmpInsuranceStandardApi.selectOne(this.userInfo.accountid).then(res => {
          if (res.code == 1) {
            this.empInsuranceStandard = res.data?res.data:{name:'~'}
            if(res.data){
              this.userInfo.unemploymentInsuranceBase = res.data.unemploymentInsuranceBase
              this.userInfo.insuranceBase = res.data.insuranceBase
              this.userInfo.registeredResidenceType = res.data.insuranceStandardId
            }

          }
        })
      },
      initUserInfo() {
        this.$loading.show()

        Api.selectOne(this.userDO.employeeDO.id).then(res => {
          if (res.code == 1) {
            this.info = res.data;
            this.getImageUrl()
            this.initBrokerageInfo()
            this.initEmpInsuranceStandard()
            this.initYearSalary()
            this.initData()
          }
        }).finally(()=>{
          this.$loading.hide()
        })

      },

      getArrayList(value){
        if(value == '~'){
          return value;
        }
        try{
          let arr = JSON.parse(value)
          return arr[0]+" / "+arr[1];
        }catch (e) {
          return '~'
        }
      },
      authEvent(){
        console.log(this.userInfo.id)
        this.$emit('auth',this.userInfo.id)
      },
      getImageUrl() {
        if (this.userInfo.headimg) {
          return this.$util.getFileUrl(this.userInfo.headimg)
        }
        return null;
      },
      updateEvent(){
        this.saveLoading = true
        this.$refs.editForm.getData().then((datas) => {
          this.execUpdate(datas)
        }).catch(()=>{
          this.$message.warning("请正确输入表单")
          this.saveLoading = false;
        })
      },
      execUpdate(datas){
        datas.formToken = this.formToken;
        InductionInvitationApi.editEmpAll(datas).then(res=>{
          if(res.code == 1){
            this.$message.success(res.message)
            this.isEdit = false
            this.initData()
            this.$nextTick(()=>{
              this.$refs.inductionDetail.initInduction()
            })

            this.$emit('flushTable')
          }else{
            this.initFormToken();
          }
        }).finally(()=>{
          this.initFormToken();
          this.saveLoading = false
        })
      },
      cancelEdit(){
        this.isEdit = false
        this.$nextTick(()=>{
          this.$refs.inductionDetail.initInduction()
        })
      },
      initData(){
        Api.selectOne(this.info.id).then(res => {
          if (res.code == 1) {
            this.userInfo = res.data
            this.$nextTick(()=>{
              console.log("初始阿虎")
              this.$refs.inductionDetail.initInduction()
            })
            this.initBrokerageInfo()
            this.initEmpInsuranceStandard()
            this.initYearSalary()

          }
        })
      },
      unlockUser(){
        this.unlockUserLoading = true
        Api.unlock(this.userInfo.accountid).then(res=>{
            if(res.code == 1){
              this.initData()
              this.$message.success(res.message)
              this.$emit('flushTable')
              this.$emit('closeDrawer')
            }
        }).finally(()=>{
          this.unlockUserLoading = false
        })
      },
      lockUser(){
        let _this = this
        this.lockUserLoading = true
        Api.lock(this.userInfo.accountid).then(res=>{
          if(res.code == 1){
            this.$message.success(res.message)
            //判断处理的用户是否为当前用户
            if(this.info.accountid === this.accountId){
              // this.$message.success(res.message)
              this.$warning({
                title:this.$t('user.loginTips.title'),
                content:this.$t('user.loginTips.content'),
                onOk:()=>{
                  this.execLogout()
                }
              })
            }else {
              this.initData()
              this.$emit('flushTable')
              this.$emit('closeDrawer')
            }
          }
        }).finally(()=>{
          this.lockUserLoading = false
        })
      },
      quit(){
        this.quitVO.visible = true
      },
      handleCancel(){
        this.quitVO.visible = false
        this.quitVO.loading = false
      },
      handleOk(){
        this.quitVO.loading = true
        this.$refs.quitFormModal.getData().then(datas=>{
          this.execQuit(datas)
        }).catch(()=>{
          this.quitVO.loading = false
        })
      },
      execQuit(datas){
        datas.accountId = this.userInfo.accountid
        let _this = this
        Api.quit(datas).then(res=>{
          if(res.code == 1){
            this.handleCancel()
            //判断处理的用户是否为当前用户
            this.$message.success(res.message)
            if(this.info.accountid === this.accountId){
              this.$warning({
                title:this.$t('user.loginTips.title'),
                content:this.$t('user.loginTips.content'),
                onOk:()=>{
                  this.execLogout()
                }
              })
            }else{
              this.initData()
              this.$emit('flushTable')
              this.$emit('closeDrawer')
            }
          }
        }).finally(()=>{
          this.quitVO.loading = false
        })
      },
      resetPassword(){
        let _this = this;
        this.$ptConfirm({
          title: _this.$t('user.resetPasswordTips.title'),
          content: _this.$t('user.resetPasswordTips.content'),
          okType: 'primary',
          onOk() {
            _this.execResetPassword()
          },
          onCancel() {

          },
        });
       },
      execResetPassword(){
        this.resetPasswordLoading = true
        Api.resetPassword(this.userInfo.accountid).then(res=>{
          if(res.code == 1){
            this.$message.success(res.message)
            //判断处理的用户是否为当前用户
            if(this.info.accountid === this.accountId){
              this.$message.success(res.message)
              this.$warning({
                title:this.$t('user.loginTips.title'),
                content:this.$t('user.loginTips.content'),
                onOk:()=>{
                  this.execLogout()
                }
              })
            }
          }
        }).finally(()=>{
          this.resetPasswordLoading = false
        })
       },
       execLogout(){
         this.Logout({}).then(() => {
           setTimeout(() => {
             window.location.reload()
           }, 16)
         }).catch(err => {

         })
       }
    }
  }
</script>

<style scoped lang="less">
  @import "../../core/diy";

  .user-detail {
    padding-bottom:80px;
    .header-operate {
      background-color: #FAFBFC;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;

      .left {
        .status {
          position: relative;
          display: flex;
          align-items: center;

          .text {
            position: absolute;
            left: 19px;
            font-size: 16px;
            color: #FA9B00;
          }

          .quit-text {
            position: absolute;
            left: 19px;
            font-size: 16px;
            color: #333;
          }
        }
      }

      .right {
        margin-right: 25px;

        button {
          margin-right: 15px;
        }
      }
    }

    .user-content {
      padding: 32px 40px 0 40px;

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 17px;

        .left {
          display: flex;
          align-items: center;

          .header-image {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            margin-right: 20px;

            img {
              width: 100px;
              height: 100px;
              border-radius: 50%;
            }
          }

          .userName {
            font-size: 24px;
            color: #333333;
          }
        }

        .right {
          font-size: 12px;
          color: #333333;
        }
      }

      .center {
        background: #FAFBFC;
        padding: 28px;

        .row {
          display: flex;
          justify-content: space-between;

          .item {
            display: flex;
            margin-bottom: 15px;

            .title {
              width: 100px;
              text-align: right;
              font-size: 12px;
              color: #999999;
            }

            .value {
              font-size: 12px;
              color: #333333;
            }
          }

          .left {
            .title {
              width: 80px;
            }
          }

          .center-content {
            .title {
              width: 100px;
            }
            .value{
              width: 142px;
            }
          }

          .right {
            .title {
              width: 100px;
            }
            .value{
              width: 80px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }

      .company-info-title {
        background: #FAFBFC;
        margin-top: 30px;
        margin-bottom: 5px;
        height: 40px;
        font-size: 14px;
        color: @text-color-3;
        display: flex;
        align-items: center;
        padding-left: 10px;

        .circle {
          background: @primary-color;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
    }


  }
</style>